export default {
	props:['item'],
	computed:{
        take(){
            return (this.item.save_take  == 'take')
        },
        money(){
            return this.$store.getters.get_product_money(this.item.gid)
        },
        discount(){
            return this.$store.getters.get_product_discount(this.item.gid)
        },
        vip : function(){
            return this.$store.getters.vip_info
        },
        show_less:function(){
            if(this.item.less % this.item.real_price)
                return "减"+this.item.less;
            else{
                return "送"+ this.item.less/this.item.real_price;
            }
        },
        isfinished:function(){
            return this.$store.getters.get_pay_info.pay_status;
        },
        prepay_money  :function(){
            return this.$store.getters.get_use_prepay_money;
        }
    },
    methods:{
    	msgpad_show(group,title,text,type){
    		this.$notify({ group, title, text, type})
    	},
    	img_url(item){
    		return "http://www.fa-xiao.com/icons/"+item.gid+".jpg"
    	},
        load_weight(){

        },
        return_it(){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};            
            this.no_prepay_money()          
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'return_it'
            })
        },
        no_prepay_money(){
            // this.$store.commit('VIP_PREPAY_MONEY', this.vip.prepay_money + this.prepay_money);
            this.$store.commit('VIP_PREPAY_MONEY_ADJUST',this.prepay_money);
            this.$store.commit('USE_PREPAY_MONEY', 0.0)
        },
        free_it(){

            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};            
            // if(this.item.less + this.item.real_price > this.money){
            if(this.money - this.item.real_price <0 || this.money < 0){
                console.log(this.item.less + this.item.real_price,this.money)
                return this.msgpad_show("msgpad","ERROR",'赠送金额不正确，不能大于商品总销售价格！','error');
            }
            this.no_prepay_money()
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'free_it'
            })
        },
        set_to_int(){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return}; 
            this.no_prepay_money()          
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'set_to_int',
                    value:this.money - parseInt(this.money)
            })
        },
        less_money(val){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            if(val != undefined){
                this.no_prepay_money() 
                this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'set_less',
                    value:val*1
                })
            }
        },
        test(){
            this.$store.commit('PRODUCTS_RESET_VIP_PRICE',{
                gid:this.item.gid,
                oper:'selected'
            })
        },
        use_vip_price(){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            this.no_prepay_money() 
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                gid:this.item.gid,
                oper:'use_vip_price',
                value:'vip'
            })
        },
        delete_it(){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                gid:this.item.gid,
                oper:'delete'
            })
        },
        triggeselect(){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};

            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                gid:this.item.gid,
                oper:'selected'
            })
        },
        inc_number(val){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                gid:this.item.gid,
                oper:'inc_num',
                value:val
            })
        },
        inc_save(val){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
             this.$store.commit('PRODUCTS_EDIT_ITEM',{
                gid:this.item.gid,
                oper:'inc_save',
                value:val
            })
        },
        set_number(val){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            if(val != undefined){
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'set_num',
                    value:val
                })
            }
        },
        set_discount(val){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            if(val != undefined){
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'set_discount',
                    value:val
                })
            }
            console.log("SET DISCOUNT:",val)
            
        },
        set_real_price(val){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            if(val != undefined){
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid:this.item.gid,
                    oper:'set_real_price',
                    value:val
                })
            }
        },
        set_to_ems(){
            if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
            this.$store.commit('PRODUCTS_EDIT_ITEM',{
                gid:this.item.gid,
                oper:'set_ems'
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/front_sale/mixin/mix_sale_item.js